import { IIcon } from "@infologistics/frontend-libraries/dist/components/Icon/types";

export const ICON_PROPS: IIcon = {
  size: 'base',
  fillColor: '#FFD898',
  fillColorMode: 'direct',
};
